import React, {useCallback, useState, useRef} from 'react';
import PropTypes from 'prop-types';

import { Button, Card, CardContent, CardHeader } from '@mui/material';
import { AppCalendar, AppChoiceList, AppFilters, AppPagination, AppSelect, AppToast } from '@shared';
import axiosRails from '@utils/axios-rails';
import { List } from 'immutable';

import withFilteredPagination from '@shared/withFilteredPagination';
import { disambiguateLabelForFilter } from 'utils';
import { pagyShape } from 'utils/shapes';

import { orderColumns } from '@utils/columns';
import AppIndexTable from '@shared/AppIndexTable';

const propTypes = {
  orders: PropTypes.array,
  statuses: PropTypes.array.isRequired,
  couriers: PropTypes.array.isRequired,
  teams: PropTypes.array.isRequired,
  admin: PropTypes.bool.isRequired,
  // Filters a deep link arrived with, already applied to the first page by the controller.
  initialFilters: PropTypes.shape({
    status: PropTypes.string,
    created_at: PropTypes.shape({ start: PropTypes.string, end: PropTypes.string }),
  }),
  pagy: pagyShape.isRequired,
  paginationClass: PropTypes.string,
  exportSubmitURL: PropTypes.string.isRequired,
}

// `new Date("2026-10-06")` is parsed as UTC midnight, which in CR/GT reads back as the
// day before. The calendar works in local days, so the parts are read out by hand.
const localDate = (value) => {
  if (!value) return null;
  const [year, month, day] = String(value).split('-').map(Number);
  return (year && month && day) ? new Date(year, month - 1, day) : null;
};

const OrdersListWithFilters = (props) => {
  const exportLinkRef = useRef(null);
  const [fileBase64, setFileBase64] = useState(0);

  const [toast, setToast] = useState("");
//////////////Date Time Picker/////////////////////////
const dateTime= new Date()
const beginDate= dateTime.setHours(0,0,0,0)
const [{month, year}, setDate] = useState({
  month: dateTime.getUTCMonth(),
  year: dateTime.getUTCFullYear(),
});
// A deep link may arrive with a creation range already applied; the calendar has to open
// on it, not on today, or the chip and the picker disagree about what is being filtered.
const initialCreatedAt = props.initialFilters && props.initialFilters.created_at;
const [selectedDates, setSelectedDates] = useState({
  start: localDate(initialCreatedAt && initialCreatedAt.start) || new Date(beginDate),
  end: localDate(initialCreatedAt && initialCreatedAt.end) || new Date(beginDate),
});
const [selectedDatesDelivered, setSelectedDatesDelivered] = useState({
  start: new Date(beginDate),
  end: new Date(beginDate),
});
// ---------------------------------------------------
const [couriers, setCouriers] = useState( " ");
const [teams,  setTeams] = useState( " ")

  const { records, loading, updateFilter, filterState, startLoading, stopLoading, setRecords, nextPage, previousPage, hasNext, hasPrevious } = props;
  const orders = records;

  const handleExport = async () => {
    try {
      startLoading();
      const response = await axiosRails.post(props.exportSubmitURL, {
        filter: filterState
      })
      const { data } = response;
      setFileBase64(`data:application/xlsx;base64,${data.base64File}`);
      exportLinkRef.current.click();
    } 
    catch (error) {
      console.error("Export error", error);
      alert("Ocurrio un error, por favor intente nuevamente.")
    }
    stopLoading();
  }

  const dismissToast = () => setToast("");
  const onUnassign = async (order) => {
    console.log("asdadadasd")
    console.log(order)
    if(loading){
      return false;
    }
    if (confirm("Esta acción es irreversible, continuar?")) {
      startLoading();
      try {
        const response = await axiosRails.post(order.unassign_url); 
        const { data } = response;
        if(data.success){
          let recordsList = List(records);
          const currentOrderIndex = recordsList.findIndex( (leOrder) => leOrder.id == data.order.id);
          if(data.can_view){ // can view unassigned order (only admins)
            setRecords( recordsList.set(currentOrderIndex, data.order).toJS() );
          }
          else{
            setRecords( recordsList.delete(currentOrderIndex).toJS() );
          }
        }
        else{
          // failed
        }
        setToast(data.message);

      } catch (error) {
        console.warn(error);
        setToast(I18n.t("messages.request_error"));
      }

      stopLoading();
    }
  }

  const updateStatus = (values) => updateFilter(values[0], "status", "filter")


  // TODO Replace all these methods with as few shared methods as possible.
  const updateCouriers = (value) => {
   value === " " ? setCouriers(" ") : setCouriers(parseInt(value))
   updateFilter(value, "courier_id", "filter")
  }

  const updateTeams= (value) => {
    setTeams(value)
    updateFilter(value[0], 'team_id', 'filter')
  }
  const updateDateCreation =(values) => {
    setSelectedDates(values)
    updateFilter(values, "created_at", "filter")
  }
  const updateDateDelivered =(values) => {
    setSelectedDatesDelivered(values)
    updateFilter(values, "delivered_at", "filter")
  }
  const updateQuery = (val) => updateFilter(val, "order_number", "delayed");
  const clearQuery = () => updateFilter("", "order_number", "delayed");
  const handleMonthChange = useCallback(
      (month, year) => setDate({month, year}),
      [],
  );

  // TODO low priority find a way to maybe reduce the amount of lines to set up the filters components
  const filters = [

    {
      key: 'status',
      label: I18n.t("activerecord.attributes.order.status"),
      filter: (
        <AppChoiceList
          title={ I18n.t("activerecord.attributes.order.status") }
          titleHidden
          choices={ props.statuses }
          selected={ [filterState.status] }
          onChange={ updateStatus }
        />
      ),
      shortcut: false,
    },
    {
      
      key: 'created_at',
      label: I18n.t("activerecord.attributes.order.created_at"),
      filter: (
          <AppCalendar
              month={month}
              year={year}
              onChange={updateDateCreation}
              onMonthChange={handleMonthChange}
              selected={selectedDates}
              allowRange={true}
          />
      ),
      shortcut: false,
    },
    {
      key: 'delivered_at',
      label: I18n.t("activerecord.attributes.order.delivered_at"),
      filter: (
          <AppCalendar
              month={month}
              year={year}
              onChange={updateDateDelivered}
              onMonthChange={handleMonthChange}
              selected={selectedDatesDelivered}
              allowRange={true}
          />
      ),
      shortcut: false,
    },
    {
      key: 'courier_id',
      label: I18n.t("activerecord.attributes.order.courier_id"),
      filter: (
          <AppSelect
              label={ I18n.t("activerecord.attributes.order.courier_id") }
              labelHidden
              options={ props.couriers }
              value={ couriers }
              onChange={ updateCouriers }
          />
      ),
      shortcut: false,
    },
  ];

  { props.admin &&
    filters.push(
        {
          key: 'team',
          label: I18n.t("activerecord.models.team.one"),
          filter: (
              <AppChoiceList
                  title={ I18n.t("activerecord.models.team.one") }
                  titleHidden
                  choices={ props.teams }
                  selected={ teams || [] }
                  onChange={ updateTeams }
              />
          ),
          shortcut: false,
        }
    )

  }

  const clearFilterAndUpdate = useCallback( (filterName, clearValue = " ", trigger = "filter") => updateFilter(clearValue, filterName, trigger), [] );
  const handleFiltersClearAll = useCallback(() => {
    clearFilterAndUpdate("status", " ", "none");
    clearFilterAndUpdate("courier_id", " ", "none");
    setCouriers(" ");
    clearFilterAndUpdate("team_id", " ", "none");
    setTeams(" ")
    clearFilterAndUpdate("created_at", {}, "none");
    clearFilterAndUpdate("delivered_at", {});
  },[clearFilterAndUpdate])

  
  // Search In Props The name from Team or Courier
  const findNameOptions= (key, value)=>{
    return props[key].find((val)=>{
      return val.value === Number(value)
    })
  }
  // OPTIMIZE. Search a way to setup at once all filters and then FILTER out those with cleared value from array instead of these many Ifs
  const appliedFilters = [];
  if (!(filterState.status == " ")){
    const key = 'status';
    appliedFilters.push({
      key,
      label: disambiguateLabelForFilter(key, filterState.status),
      onRemove: () => clearFilterAndUpdate(key),
    });
  }
  if (!(filterState.courier_id == " ")) {
    const key = 'couriers';
    appliedFilters.push({
      key,
      label: disambiguateLabelForFilter(key, findNameOptions(key,filterState.courier_id)),
      onRemove: () => { clearFilterAndUpdate("courier_id"), setCouriers(" ") },
    });
  }
  if (!(filterState.team_id == " ")) {
    const key = 'teams';
    appliedFilters.push({
      key,
      label: disambiguateLabelForFilter(key, findNameOptions(key, filterState.team_id)),
      onRemove: () => { clearFilterAndUpdate("team_id"), setTeams(" ") },
    });
  }
  if(!(JSON.stringify(filterState.created_at) === '{}' )){
    const key = 'created_at';
    appliedFilters.push({
      key,
      label: disambiguateLabelForFilter(key, selectedDates),
      onRemove: () => clearFilterAndUpdate("created_at", {}),
    });
  }
  if(!(JSON.stringify(filterState.delivered_at) === '{}' )){
    const key = 'delivered_at';
    appliedFilters.push({
      key,
      label: disambiguateLabelForFilter(key, selectedDates),
      onRemove: () => clearFilterAndUpdate("delivered_at", {}),
    });
  }

  const handleSort = (key, direction) => updateFilter({ value: key, order: direction }, "sort", "filter");

  // The Polaris <Filters> needed its own <AppProvider> to be translated; the
  // MUI one carries its Spanish strings itself.
  const filterControl = (
    <AppFilters
      queryPlaceholder='ID orden, recibido por, número de orden, número de tracking'
      queryValue={ filterState.order_number }
      filters={filters}
      appliedFilters={appliedFilters}
      onQueryChange={ updateQuery }
      onQueryClear={ clearQuery }
      onClearAll={handleFiltersClearAll}
    />
  )

  return (
    <div>
      <div className="flex justifyEnd alignItemsCenter pv12">
        <Button variant="contained" onClick={ handleExport }>
          Exportar XLSX
        </Button>
        <a id="export-placeholder-link" ref={ exportLinkRef } href={ fileBase64 } download={`orders.xlsx`}></a>
      </div>
      <Card>
        <CardHeader title={ I18n.t("app.last_orders") } titleTypographyProps={{ variant: 'h6' }} />
        <CardContent>
          <AppIndexTable
            items={orders}
            columnsInfo={orderColumns}
            header={ filterControl }
            loading={ loading }
            accessorUtils={{
              baseUrl: props.admin ? "/orders/:id" : undefined,
              onUnassign,
            }}
            sort={ filterState.sort }
            onSort={ handleSort }
          />
          <div className="flex justifyCenter mt20 mb10">
            <AppPagination
              hasPrevious={ hasPrevious }
              onPrevious={ previousPage }
              hasNext={ hasNext }
              onNext={ nextPage }
            />
          </div>
          { toast && <AppToast content={toast} onDismiss={ dismissToast } /> }
        </CardContent>
      </Card>
    </div>
  );
}

OrdersListWithFilters.propTypes = propTypes;

export default withFilteredPagination(OrdersListWithFilters, {
  mapPropsToInitialRecords: (props) => props.orders,
  // `initialFilters` lets a deep link open the list pre-filtered; the controller applied
  // the very same filters to the first page, so the chips, the rows and the next filter
  // POST all agree. Spread last so a link only overrides the keys it actually carries.
  mapPropsToInitialFilters: (props) => ({
    order_number: "",
    status: " ",
    created_at: {},
    delivered_at:{},
    courier_id: " ",
    team_id: " ",
    sort: { value: null, order: null },
    ...(props.initialFilters || {}),
  }),
  mapPropsToPagy: (props) => props.pagy,
  paramsName: "filter",
  filterURL: "/orders/filter",
  paginationClass: (props) => props.paginationClass,
});

// {
//   toast &&
//   <Toast content={toast} onDismiss={dismissToast} />
// }